import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";

/**
 * Renders a tiered "New Personal Best" badge from a training-submit response.
 * Only one badge shows at a time (all-time > monthly > weekly).
 * Returns null if none of the flags are true.
 */
const TIERS = [
  {
    flag: "is_new_personal_best",
    label: "NEW PERSONAL BEST",
    tint: "bg-lime-500/20 border-lime-400 text-lime-300",
  },
  {
    flag: "is_new_monthly_best",
    label: "NEW MONTHLY BEST",
    tint: "bg-purple-500/20 border-purple-400 text-purple-300",
  },
  {
    flag: "is_new_weekly_best",
    label: "NEW WEEKLY BEST",
    tint: "bg-pink-500/20 border-pink-400 text-pink-300",
  },
];

export const PersonalBestBadge = ({ results }) => {
  if (!results) return null;
  const tier = TIERS.find((t) => results[t.flag]);
  if (!tier) return null;
  return (
    <motion.div
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className={`inline-flex items-center gap-2 mt-4 mb-6 px-4 py-2 rounded-full border font-bold text-sm ${tier.tint}`}
      data-testid="npb-badge"
    >
      <Sparkles className="w-4 h-4" /> {tier.label}
    </motion.div>
  );
};

export default PersonalBestBadge;
